function doAjax(p)
{
	p = jQuery.extend({
		ajaxUrl: '/ajax',
		method: 'POST',
		cache: false,
		data: [],
		onSuccess: null,
		onError: null,
		params: {},
		processData: true,
		contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
	}, p);

	/*if (p.data instanceof FormData) p.data.append('frontAjax', true);
	else if (typeof p.data == 'string') p.data += '&frontAjax=true';
	else if (p.data.action !== undefined) p.data.frontAjax = true;
	else p.data.push({name: 'frontAjax', value: true});*/

	return jQuery.ajax(
	{
		url: p.ajaxUrl,
		cache: p.cache,
		type: p.method,
		data: p.data,
		processData: p.processData,
  		contentType: p.contentType,
		success: function(response)
		{
			if(p.onSuccess !== null) p.onSuccess(response, p.params); //call the supplied callback function
		},
		error: function(jqxhr, textStatus, errorThrown)
		{
			if(p.onError !== null) p.onError(jqxhr, textStatus, errorThrown, p.params); //call the supplied callback function
		}
	});
}
function userAbortedAjax(xhr) { return !xhr.getAllResponseHeaders(); }

/*
	function _updateExample()
	{
		//do ajax call
		var data = $form.serializeArray();
		data.push({ name: 'action', value: 'example' });
		doAjax({
			data: data,
			onSuccess: _onLoadSuccess,
			onError: _onLoadError,
			params: { foo: 'bar' }
		});
	}

		function _onLoadSuccess(rawResponse, params)
		{
			try
			{
				var response = $.parseJSON(rawResponse);

				if (response.success)
				{

				}
				else throw new Error(response.message);
			}
			catch (err) { lmnDialog.alert(err.message); }
		}


		function _onLoadError(jqxhr, textStatus, errorThrown, params)
		{
			//error?
			if (!userAbortedAjax(jqxhr)) lmnDialog.alert(errorThrown);
		}
*/



/*
 app dependencies
 - var body

 lib dependencies
*/

const lmnDynamicPageContents = (function($)
{

	const _triggers = document.querySelectorAll('.js-dynamic-page-contents');

	//module functions
	function init()
	{
		if (!_triggers.length) return;

		const requests = [];

		Array.from(_triggers).forEach(function(el)
		{
			//assign element id if absent
			if (!el.id) el.id = `dpc-${uuid()}`;

			//setup request and save reference to element id
			const req = { elementId: el.id };

			//collect params
			for (const key in el.dataset)
			{
				if (key.substr(0,3) == 'dpc')
				{
					req[key.charAt(3).toLowerCase() + key.substr(4)] = el.dataset[key];
				}
			}

			//push the request
			requests.push(req);
		});

		doAjax({
			ajaxUrl: '/ajax/get-dynamic-page-contents',
			data: { requests },
			onSuccess: _onLoadSuccess,
			onError: _onLoadError
		});
	}

		function _onLoadSuccess(rawResponse, params)
		{
			try
			{
				var response = $.parseJSON(rawResponse);
				if (response.success)
				{
					response.responses.forEach(function(r)
					{
						try
						{
							if (r.html || r.innerHtml || r.outerHtml || r.replaceWith)
							{
								const el = document.getElementById(r.elementId);

								if (r.html || r.innerHtml)
								{
									el.innerHTML = r.html || r.innerHtml;
								}
								if (r.outerHtml || r.replaceWith)
								{
									el.outerHTML = r.outerHtml || r.replaceWith;
								}
							}

							if (r.fn)
							{
								//r.fn = function by dot notation, ie. myModule.myFunctions.myFunction
								const fn = propertyByDotString(r.fn);
								if (fn)
								{
									//r.args = array with arguments for function
									if (r.args instanceof Array) fn(...r.args);
									else fn();
								}
							}
						}
						catch (err)
						{
							//console.log(err);
						}
					});

					document.body.classList.add('dynamic-page-contents-loaded');
				}
				else
				{
					document.body.classList.add('dynamic-page-contents-failed');
					throw new Error(response.message);
				}
			}
			catch (err) { alert(err.message); }
		}


		function _onLoadError(jqxhr, textStatus, errorThrown, params)
		{
			document.body.classList.add('dynamic-page-contents-failed');
		}

	//reveal public vars and functions
	return {
		//vars

		//functions
		init
	};

})(jQuery);

/*var testMod = (function()
{
	const fns =
	{
		bla: function() { console.log('function bla executed'); },
		mwaap: function(a) {console.log('function mwaap executed: '+a); }
	};

	const arr =
	[
		function() { console.log('arr.0'); },
		function() { console.log('arr.1'); }
	]

	function fn()
	{
		console.log('fn executed');
	};

	function eventTest(arg)
	{
		document.querySelector('.js-aol-event-test').addEventListener('click', function(e)
		{
			e.preventDefault();
			alert(arg + ', never gonna let you down');
		});
	}

	return {
		fn,
		fns,
		arr,
		eventTest
	}
})();*/
